import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react"; import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Grid } from '@mui/material';
import { tabs } from './tabs/tabs';
import './gestionProfesionalCreationContent.scss';
import CustomTabs, { TabPanels } from '../../../components/tabs/Tabs';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { adaptProfesionalDetalle, GET_PROFESIONAL_BY_ID } from '../../../data/graphQL/queries/Profesionales/getProfesionalById';
import { adaptProfesional, CREATE_AND_UPDATE_PROFESIONAL } from '../../../data/graphQL/mutations/Profesionales/createAndUpdateProfesional';
import toast from 'react-hot-toast';
import moment from 'moment';
import { adaptSegurosMalaPraxis, GET_ARCHIVOS_PROFESIONAL_LITE } from '../../../data/graphQL/queries/Profesionales/getArchivosProfesional';

const TIPO_PROFESIONAL_MEDICO = 1;
const TIPO_PROFESIONAL_ENFERMERO = 2;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const phoneRegex = /^\+[0-9]{0,14}$/;

export const GestionProfesionalCreationContent = ({ setChildrenAction }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    idProfesional,
    allowedWrite,
    isNew,
    tipoProfesionales,
    idDelegacion,
    delegaciones,
    activeTab = 0
  } = location.state;

  const [datosGeneralesFormData, setDatosGeneralesFormData] = useState({});
  const [datosContactoFormData, setDatosContactoFormData] = useState({});
  const [datosSeleccionFormData, setDatosSeleccionFormData] = useState({});
  const [delegacionFormData, setDelegacionFormData] = useState({});
  const [datosProfesionalInicial, setDatosProfesionalInicial] = useState({});

  const [tabsGestionProf, setTabsGestionProf] = useState(tabs);
  const initialTabIndex = 0;
  const [currentTabIndex, setCurrentTabIndex] = useState(activeTab);
  const [currentTab, setCurrentTab] = useState({});
  const [funcionCuidadorId, setFuncionCuidadorId] = useState(null);
  const [desactivadoAMano, setDesactivadoAMano] = useState(false);

  const handleChangeTab = (tabIndex) => {
    setCurrentTabIndex(tabIndex);
    setCurrentTab(tabsGestionProf[tabIndex]);
  };

  const [getArchivosProfesional, { data: profesionalAdjuntos, loading: archivosLoading }] = useLazyQuery(GET_ARCHIVOS_PROFESIONAL_LITE, {
    fetchPolicy: 'network-only'
  });

  useEffect(() => {
    if (!profesionalAdjuntos) return;
    setDatosSeleccionFormData((prevData) => ({
      ...prevData,
      curriculumCheck: !!profesionalAdjuntos?.profesionalAdjuntos.curriculum?.length,
      curriculum: profesionalAdjuntos?.profesionalAdjuntos.curriculum,
      contratoCheck: !!profesionalAdjuntos?.profesionalAdjuntos.contrato?.length,
      contrato: profesionalAdjuntos?.profesionalAdjuntos.contrato,
      certificadoVacunacionCheck: !!profesionalAdjuntos?.profesionalAdjuntos.certificadoVacunacion?.length,
      certificadoVacunacion: profesionalAdjuntos?.profesionalAdjuntos.certificadoVacunacion,
      seguroMalaPraxis: adaptSegurosMalaPraxis(profesionalAdjuntos?.profesionalAdjuntos.seguroMalaPraxis || []),
      tituloHabilitanteCheck: !!profesionalAdjuntos?.profesionalAdjuntos.tituloHabilitante?.length,
      tituloHabilitante: profesionalAdjuntos?.profesionalAdjuntos.tituloHabilitante,
      firmaPersonalCheck: !!profesionalAdjuntos?.profesionalAdjuntos.firmaDigital?.archivo,
      firmaDigital: profesionalAdjuntos?.profesionalAdjuntos.firmaDigital,
      matriculaCheck: !!profesionalAdjuntos?.profesionalAdjuntos.matricula?.length,
      matricula: profesionalAdjuntos?.profesionalAdjuntos.matricula
    }));
  }, [profesionalAdjuntos]);


  const [getProfesional, { data: profesionalDetalle, loading: profesionalLoading }] = useLazyQuery(GET_PROFESIONAL_BY_ID, {
    fetchPolicy: 'network-only'
  });

  useEffect(() => {
    if (!profesionalDetalle) return;
    const profesionalAdapted = adaptProfesionalDetalle(profesionalDetalle.profesionalDetalle);
    setDatosProfesionalInicial(profesionalAdapted);
    setDatosGeneralesFormData((prev) => ({
      ...prev,
      ...profesionalAdapted?.datosGenerales
    })
    );
    setDatosContactoFormData((prev) => ({
      ...prev,
      ...profesionalAdapted?.datosContacto
    }));
    setDatosSeleccionFormData((prev) => ({
      ...prev,
      ...profesionalAdapted?.datosSeleccion
    }));
    setDelegacionFormData((prev) => ({
      ...prev,
      ...profesionalAdapted?.datosDelegaciones
    }));
  }, [profesionalDetalle]);


  useEffect(() => {
    if (!idProfesional) return;
    getProfesional({ variables: { idProfesional } });
    getArchivosProfesional({variables: { idProfesional }});
  }, [idProfesional]);

  const [guardarProfesional, { loading: guardarLoading }] = useMutation(CREATE_AND_UPDATE_PROFESIONAL, {
    fetchPolicy: 'no-cache'
  });

  const isValid = () => {
    const errorMessages = [];

    //Datos mínimos para crear al profesional
    const { nombre, apellido, idTipoProfesional } = datosGeneralesFormData;
    const { idDelegacionMonitoreo } = delegacionFormData;

    if (!nombre?.trim())
      errorMessages.push('Debe ingresar Nombre.\n');

    if (!apellido?.trim())
      errorMessages.push('Debe ingresar Apellido.\n');

    if (!idTipoProfesional)
      errorMessages.push('Debe ingresar un Tipo profesional.\n');

    if (!idDelegacionMonitoreo)
      errorMessages.push('Debe ingresar una Delegacion de Monitoreo.\n');

    if (errorMessages.length > 0) {
      toast.error(errorMessages.join(' '));
      return false;
    }

    return true;
  };


  const puedeEstarActivo = (isFromModify, mostrarToast) => {
    const {
      idTipoProfesional,
      idFuncion,
      idEspecialidad,
      nombre,
      apellido,
      numeroDoc,
      sexo,
      email,
      fechaNacimiento,
      cod_Proveedor
    } = datosGeneralesFormData;

    const {
      calle,
      numero,
      idProvincia,
      idLocalidad,
      codigoPostal,
      latitud,
      longitud,
      telefonoParticular,
      telefonoMovil,
      telefonoLaboral
    } = datosContactoFormData;

    const { idDelegacionMonitoreo } = delegacionFormData;

    const {
      matriculas,
      firmaDigital,
      seguroMalaPraxis,
      contrato,
      tituloHabilitante,
      certificadoVacunacion
    } = datosSeleccionFormData;

    const errores = [];

    // //VALIDACIONES DATOS GENERALES
    if (!idTipoProfesional)
      errores.push('Debe ingresar un Tipo profesional.');

    if (!!idTipoProfesional && idTipoProfesional === TIPO_PROFESIONAL_ENFERMERO && !idFuncion)
      errores.push('Debe ingresar una Función.');

    if (!!idTipoProfesional && idTipoProfesional === TIPO_PROFESIONAL_MEDICO && !idEspecialidad)
      errores.push('Debe ingresar una Especialidad.');

    if (!nombre?.trim())
      errores.push('Debe ingresar Nombre.');

    if (!apellido?.trim())
      errores.push('Debe ingresar Apellido.');

    if (!numeroDoc?.trim())
      errores.push('Debe ingresar numero documento. ');

    if (!sexo?.trim())
      errores.push('Debe ingresar el sexo. ');

    if (!email?.trim())
      errores.push('Debe ingresar un Email. ');

    if (!!email?.trim() && !emailRegex.test(email))
      errores.push('Debe ingresar un Email válido. ');

    if (!fechaNacimiento || !moment(fechaNacimiento).isValid() || moment().isBefore(moment(fechaNacimiento)))
      errores.push('Debe ingresar una Fecha de nacimiento válida.');

    if (!cod_Proveedor?.trim())
      errores.push('Debe ingresar Código SAP. ');

    // //VALIDACIONES DATOS CONTACTO
    if (!calle)
      errores.push('Debe ingresar una calle.');

    if (!numero)
      errores.push('Debe ingresar un número de calle.');

    if (!idProvincia)
      errores.push('Debe ingresar una Provincia.');

    if (!idLocalidad)
      errores.push('Debe ingresar una Localidad.');

    if (!codigoPostal)
      errores.push('Debe ingresar un Código Postal.');

    if (!latitud || !longitud)
      errores.push('Debe verificar geoposición.');

    if (!telefonoMovil)
      errores.push('Debe ingresar un teléfono móvil.');

    if (
      !!telefonoParticular && !phoneRegex.test(telefonoParticular) ||
      !!telefonoMovil && !phoneRegex.test(telefonoMovil) ||
      !!telefonoLaboral && !phoneRegex.test(telefonoLaboral))

      errores.push('Los teléfonos deben comenzar con el formato +54.');

    // //VALIDACIONES DATOS DELEGACIONES
    if (!idDelegacionMonitoreo)
      errores.push('Debe ingresar una Delegacion de Monitoreo.');

    
    // //VALIDACIONES DATOS SELECCION
    if (!tituloHabilitante?.length && !esEnfermeroCuidador) {
      errores.push('Cargar título habilitante');
    }

    if (!esEnfermeroCuidador && !esRehabilitador && (matriculas?.length === 0 || !matriculas?.some((m) => moment(m.fechaVencimiento).isSameOrAfter(moment(), 'day')))) {
      errores.push('Cargar al menos una matrícula vigente');
    }

    if (!esEnfermeroCuidador && !esRehabilitador && !certificadoVacunacion?.length) {
      errores.push('Cargar certificado de vacunación');
    }

    if (!contrato?.length) {
      errores.push('Cargar firma del contrato');
    }

    if (!firmaDigital) {
      errores.push('Cargar firma Personal');
    }

    if ((esMedico || esPsiquiatra || esNutricionista) && (!seguroMalaPraxis || seguroMalaPraxis.length === 0 || !seguroMalaPraxis.some((s) => moment(s.fechaHasta).isSameOrAfter(moment(), 'day')))) {
      errores.push('Cargar al menos un seguro de mala praxis vigente');
    }

    if (errores.length > 0) {
      if (mostrarToast) {
        const fromModifyText = 'No se puede activar el profesional. Faltan los siguientes requisitos:\n';
        const fromSaveText = 'Se desactivó el profesional, para activarlo debe completar los siguientes requisitos:\n';

        toast.error(`${isFromModify ? fromModifyText : fromSaveText} ${errores.join('\n')}`);
      }
      return false;
    }
    return true;
  };

  const handleGuardar = () => {
    if (isValid()) {
      const datosGenerales = { ...datosGeneralesFormData };

      // Si no está activo y fue desactivado a mano, no validar puedeEstarActivo
      if (!datosGenerales?.activo && desactivadoAMano) {

        // No hacer nada con puedeEstarActivo
      } // Si no está activo y no fue desactivado a mano, validar puedeEstarActivo y activar si corresponde
      else if (!datosGenerales?.activo && !desactivadoAMano) {
        const canBeActive = puedeEstarActivo(false, false);
        if (canBeActive) {
          datosGenerales.activo = true;
          setDatosGeneralesFormData(datosGenerales);
        }
      }
      // Si está activo y no puede estar activo, desactivar
      else if (datosGenerales?.activo) {
        const canBeActive = puedeEstarActivo(false, true);
        if (!canBeActive) {
          datosGenerales.activo = false;
          setDatosGeneralesFormData(datosGenerales);
        }
      }

      const promise = guardarProfesional({
        variables: {
          input: adaptProfesional(
            idProfesional,
            datosGenerales,
            datosContactoFormData,
            datosSeleccionFormData,
            delegacionFormData
          )
        }
      }).then(async ({ data }) => {
        if (data?.createAndUpdateProfesional?.error) {
          throw new Error(data?.createAndUpdateProfesional?.error);
        }
        navigate('/asistencial/gestionProfesionales');
      });

      toast.promise(promise, {
        loading: 'Guardando Profesional...',
        success: 'Profesional guardado.',
        error: (err) => err.message || 'Ocurrió un error al intentar guardar Profesional.'
      }).catch(() => { });
    }
  };

  const reiniciarMatriculas = () => {
    setDatosSeleccionFormData((prev) => ({
      ...prev,
      matriculas: []
    }));
  };

  const guardarGeneralLoading = useMemo(() => {
    return profesionalLoading || archivosLoading || guardarLoading;
  }, [profesionalLoading, archivosLoading, guardarLoading]);

  const generalLoading = useMemo(() => {
    return profesionalLoading || archivosLoading;
  }, [profesionalLoading, archivosLoading]);

  const tipoProfesionalesMap = useMemo(() => {
    const map = {};
    tipoProfesionales.forEach((opt) => {
      if (opt.displayName.toLowerCase().includes("medico")) map.MEDICO = opt.id;
      if (opt.displayName.toLowerCase().includes("nutricionista")) map.NUTRICIONISTA = opt.id;
      if (opt.displayName.toLowerCase().includes("kinesiólogo")) map.KINESIOLOGO = opt.id;
      if (opt.displayName.toLowerCase().includes("terapista")) map.TERAPISTA_OCUPACIONAL = opt.id;
      if (opt.displayName.toLowerCase().includes("rehabilitador")) map.REHABILITADOR = opt.id;
      if (opt.displayName.toLowerCase().includes("enfermero")) map.ENFERMERO = opt.id;
      if (opt.displayName.toLowerCase().includes("asistente social")) map.ASISTENTE_SOCIAL = opt.id;
      if (opt.displayName.toLowerCase().includes("psiquiatra")) map.PSIQUIATRA = opt.id;
    });
    return map;
  }, [tipoProfesionales]);

  const esEnfermeroCuidador = useMemo(() => {
    const idTipoProfesional = datosGeneralesFormData?.idTipoProfesional;
    const idFuncion = datosGeneralesFormData?.idFuncion;
    // Si es enfermero y la función es cuidador, devolver true
    return (
      idTipoProfesional === TIPO_PROFESIONAL_ENFERMERO &&
      funcionCuidadorId &&
      idFuncion === funcionCuidadorId);

  }, [datosGeneralesFormData?.idTipoProfesional, datosGeneralesFormData?.idFuncion, funcionCuidadorId]);

  const {
    esAsistenteSocial,
    esPsiquiatra,
    esMedico,
    esRehabilitador,
    esNutricionista
  } = useMemo(() => {
    const idTipoProfesional = datosGeneralesFormData?.idTipoProfesional;
    return {
      esAsistenteSocial: idTipoProfesional === tipoProfesionalesMap.ASISTENTE_SOCIAL,
      esPsiquiatra: idTipoProfesional === tipoProfesionalesMap.PSIQUIATRA,
      esMedico: idTipoProfesional === tipoProfesionalesMap.MEDICO,
      esNutricionista: idTipoProfesional === tipoProfesionalesMap.NUTRICIONISTA,
      esRehabilitador: idTipoProfesional === tipoProfesionalesMap.REHABILITADOR
    };
  }, [datosGeneralesFormData?.idTipoProfesional, tipoProfesionalesMap]);

  const delegacionesUsuario = useMemo(() => {
    return delegaciones?.filter((x) => !!x.id && x.id > 0);
  }, [delegaciones]);

  useEffect(() => {
    if (!!datosGeneralesFormData?.id) {
      setTabsGestionProf((prevTabs) => prevTabs.map((tab) => {
        if (tab.id === 2 || tab.id === 3 || tab.id === 4)
          return { ...tab, disabled: false };
        else
          return tab;
      }));
    }
  }, [datosGeneralesFormData]);

  useEffect(() => {
    setChildrenAction(() =>
      <div className='top-buttons'>
        {allowedWrite && <div className='header-plan-cuidado'>
          <CustomButton
            size='small'
            isLoading={guardarGeneralLoading}
            disabled={guardarGeneralLoading}
            onClick={handleGuardar}>

            Guardar
          </CustomButton>
        </div>}
      </div>
    );
  }, [setChildrenAction,
    guardarGeneralLoading,
    datosGeneralesFormData,
    datosContactoFormData,
    datosSeleccionFormData,
    delegacionFormData]
  );

  return (
    <div className='gestion-profesional-creation-content'>
      <Grid container>
        <Grid sx={{ width: '100%' }} size={{ xs: 12 }}>
          <CustomTabs
            tabs={tabsGestionProf}
            currentTabIndex={currentTabIndex}
            initialTabIndex={initialTabIndex}
            handleChangeTab={handleChangeTab} />

          <div className='tab-content-container'>
            <div className='tab-content'>
              <TabPanels
                tabs={tabsGestionProf}
                isNew={isNew}
                initialTabIndex={initialTabIndex}
                currentTabIndex={currentTabIndex}
                profesionalLoading={generalLoading}
                tipoProfesionales={tipoProfesionales}
                delegacionesUsuario={delegacionesUsuario}
                datosGeneralesFormData={datosGeneralesFormData}
                datosContactoFormData={datosContactoFormData}
                datosSeleccionFormData={datosSeleccionFormData}
                delegacionFormData={delegacionFormData}
                setDatosGeneralesFormData={setDatosGeneralesFormData}
                setDatosContactoFormData={setDatosContactoFormData}
                setDatosSeleccionFormData={setDatosSeleccionFormData}
                setDelegacionFormData={setDelegacionFormData}
                allowedWrite={allowedWrite}
                idProfesional={idProfesional}
                idDelegacion={idDelegacion}
                tipoProfesionalesMap={tipoProfesionalesMap}
                funcionCuidadorId={funcionCuidadorId}
                setFuncionCuidadorId={setFuncionCuidadorId}
                esEnfermeroCuidador={esEnfermeroCuidador}
                esAsistenteSocial={esAsistenteSocial}
                esRehabilitador={esRehabilitador}
                puedeEstarActivo={puedeEstarActivo}
                desactivadoAMano={desactivadoAMano}
                setDesactivadoAMano={setDesactivadoAMano}
                datosProfesionalInicial={datosProfesionalInicial}
                reiniciarMatriculas={reiniciarMatriculas} />

            </div>
          </div>
        </Grid>
      </Grid>
    </div>);

};